<h6 class="form-header h6-icon">
  {{ 'RELATIONS.EDITDIALOG.FORM.HEADER.PERSONALINFO' | translate }}
</h6>
<div class="form-group" [formGroup]="PrimaryContact">
  <div class="row">
    <div class="col-6 form-group">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.GENDER' | translate }}@if (PrimaryContact.get('Gender').hasValidator(requiredValidator)) {
          <span class="tx-danger">*</span>
        }
      </label>
      <div class="d-flex">
        @for (gender of selectableGenders; track gender.value) {
          <div class="form-check me-4">
            <input class="form-check-input" type="radio" formControlName="Gender" [value]="gender.value" id="gender{{ gender.value }}">
            <label class="form-check-label" for="gender{{ gender.value }}">{{ gender.viewValue }}</label>
          </div>
        }
      </div>
      <t4-display-validation controlName="Gender" [form]="PrimaryContact" [messages]="validationMessages">
      </t4-display-validation>
    </div>
    <div class="col-6 form-group">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.INITIALS' | translate }}@if (PrimaryContact.get('Initials').hasValidator(requiredValidator)) {
          <span class="tx-danger">*</span>
        }
      </label>
      <input class="form-control" name="initials" formControlName="Initials">
      <t4-display-validation controlName="Initials" [form]="PrimaryContact" [messages]="validationMessages">
      </t4-display-validation>
    </div>
  </div>

  <div class="row">
    <div class="col-5 form-group">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.FIRSTNAME' | translate }} @if (PrimaryContact.get('FirstName').hasValidator(requiredValidator)) {
          <span class="tx-danger">*</span>
        }
      </label>
      <input class="form-control" name="firstname" formControlName="FirstName">
      <t4-display-validation controlName="FirstName" [form]="PrimaryContact" [messages]="validationMessages">
      </t4-display-validation>
    </div>
    <div class="col-3 form-group">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.MIDDLENAME' | translate }}@if (PrimaryContact.get('MiddleName').hasValidator(requiredValidator)) {
          <span class="tx-danger">*</span>
        }
      </label>
      <input class="form-control" name="middlename" formControlName="MiddleName">
    </div>
    <div class="col-4 form-group">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.LASTNAME' | translate }}@if (PrimaryContact.get('LastName').hasValidator(requiredValidator)) {
          <span class="tx-danger">*</span>
        }
      </label>
      <input class="form-control" name="lastname" formControlName="LastName">
      <t4-display-validation controlName="LastName" [form]="PrimaryContact" [messages]="validationMessages">
      </t4-display-validation>
    </div>
  </div>

  <div class="row">
    <div class="form-group col-12 parsley-input parsley-error">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.DATEOFBIRTH' | translate }}@if (PrimaryContact.get('DateOfBirth').hasValidator(requiredValidator)) {
          <span class="tx-danger">*</span>
        }
      </label>
      <input class="form-control" datepicker [beforeToday]="true" formControlName="DateOfBirth">
      <t4-display-validation controlName="DateOfBirth" [form]="PrimaryContact" [messages]="validationMessages">
      </t4-display-validation>
    </div>
  </div>

  <h6 class="form-header h6-icon">
    {{ 'RELATIONS.EDITDIALOG.FORM.HEADER.CONTACTINFO' | translate }}
  </h6>

  <div class="row">
    <div class="col-6 form-group">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.EMAIL' | translate }}@if (PrimaryContact.get('Email').hasValidator(requiredValidator)) {
          <span class="tx-danger">*</span>
        }
      </label>
      <input trim class="form-control" name="email" formControlName="Email">
      <t4-display-validation controlName="Email" [form]="PrimaryContact" [messages]="validationMessages">
      </t4-display-validation>
    </div>
    <div class="col-6 form-group">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.TELEPHONE' | translate }}@if (PrimaryContact.get('MobileNr').hasValidator(requiredValidator)) {
          <span class="tx-danger">*</span>
        }
      </label>
      <input class="form-control" name="phonenumber" formControlName="MobileNr">
      <t4-display-validation controlName="MobileNr" [form]="PrimaryContact" [messages]="validationMessages">
      </t4-display-validation>
    </div>
  </div>

  <div class="row">
    <div class="col-12 form-group">
      <label class="form-control-label">
        {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.LANGUAGE' | translate }}
      </label>
      <ng-select [items]="SelectableLanguages" bindLabel="Name" bindValue="Id" formControlName="LanguageId" placeholder="{{ 'RELATIONS.EDITDIALOG.FORM.PLACEHOLDER.DEFAULT' | translate }}"
        [clearable]="true" notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}" appendTo="body"></ng-select>
      <t4-display-validation controlName="LanguageId" [form]="PrimaryContact" [messages]="validationMessages"></t4-display-validation>
    </div>
  </div>

  @if (isUsingSASSO) {
    <div class="row">
      <div class="col-12 form-group">
        <label class="form-control-label">
          {{ 'RELATIONS.EDITDIALOG.FORM.LABEL.SSOID' | translate }}
        </label>
        <div class="row">
          <div class="col-8 form-group">
            <input trim class="form-control" name="ssoid" formControlName="SSOId">
          </div>
          @if (primaryContact?.SSOId) {
            <div class="col-4 form-group">
              <button (click)="deleteSSOId()" type="button" class="btn btn-grid btn-round mdi mdi-danger mdi-trash-can-outline" style="margin-top: 6px;"></button>
            </div>
          }
        </div>
      </div>
    </div>
  }
</div>
